export default __webpack_public_path__ + "static/media/lightroom.0e67d833.svg";